// // src/components/BrandAudit/Step10_FinalVerdict.jsx
// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { GoogleGenerativeAI } from '@google/generative-ai';
// import { computeOverallScore } from '../../utils/scoreUtils';

// // ─────────────────────────────────────────────────────────────────────────
// // Constants
// // ─────────────────────────────────────────────────────────────────────────
// const CACHE_TTL     = 24 * 60 * 60 * 1000; // 24h for audit data
// const VERDICT_TTL   = 24 * 60 * 60 * 1000; // 24h for AI verdict
// const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

// // ─────────────────────────────────────────────────────────────────────────
// // Helpers
// // ─────────────────────────────────────────────────────────────────────────
// const cleanDomain = (url) =>
//   url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim() || '';

// const loadCached = (key) => {
//   try {
//     const raw = localStorage.getItem(key);
//     if (!raw) return null;
//     const { timestamp, data } = JSON.parse(raw);
//     return Date.now() - timestamp < CACHE_TTL ? data : null;
//   } catch { return null; }
// };

// const loadDACached = (key) => {
//   try {
//     const raw = localStorage.getItem(key);
//     if (!raw) return null;
//     const { ts, d } = JSON.parse(raw);
//     return Date.now() - ts < CACHE_TTL ? d : null;
//   } catch { return null; }
// };

// const loadAICached = (key) => {
//   try {
//     const raw = localStorage.getItem(key);
//     if (!raw) return null;
//     const { ts, text } = JSON.parse(raw);
//     return Date.now() - ts < VERDICT_TTL ? text : null;
//   } catch { return null; }
// };

// const saveAICache = (key, text) => {
//   try {
//     localStorage.setItem(key, JSON.stringify({ ts: Date.now(), text }));
//   } catch {}
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Gemini caller
// // ─────────────────────────────────────────────────────────────────────────
// const genAI = GEMINI_API_KEY ? new GoogleGenerativeAI(GEMINI_API_KEY) : null;

// const callGemini = async (prompt) => {
//   if (!genAI) throw new Error('REACT_APP_GEMINI_API_KEY not set');
//   const model  = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
//   const result = await model.generateContent(prompt);
//   return result.response.text();
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Data aggregation — single source of truth
// // ─────────────────────────────────────────────────────────────────────────
// const buildAuditData = () => {
//   // ── Form data ──────────────────────────────────────────────────────────
//   let brandName = '', websiteUrl = '', location = '',
//       pillarKeywords = [], industry = '', gmbLink = '', placeId = '';
//   try {
//     const fd = JSON.parse(localStorage.getItem('auditFormData') || '{}');
//     brandName      = fd.brandName      || '';
//     websiteUrl     = fd.websiteUrl     || '';
//     location       = fd.locations?.[0]?.city    || '';
//     gmbLink        = fd.locations?.[0]?.gmbLink || '';
//     pillarKeywords = fd.pillarKeywords || [];
//     industry       = fd.industry       || '';
//   } catch {}
//   // placeId is persisted in lastAuditInfo by BrandAuditWizard
//   try {
//     const ai = JSON.parse(localStorage.getItem('lastAuditInfo') || '{}');
//     placeId = ai.placeId || '';
//   } catch {}

//   const domain = cleanDomain(websiteUrl) || brandName.toLowerCase().replace(/\s/g, '');

//   // ── Competitors ────────────────────────────────────────────────────────
//   let competitorsList = [];
//   try { competitorsList = JSON.parse(localStorage.getItem('competitors_list') || '[]'); } catch {}

//   // ── Overall score ──────────────────────────────────────────────────────
//   const scoreCache  = loadCached(`overallScore_${domain}`);
//   const overallScore = scoreCache?.overallScore ?? 0;

//   // ── Domain Authority ───────────────────────────────────────────────────
//   const daData          = loadDACached(`domainAuthority_${domain}`);
//   const domainAuthority = daData?.domain_authority ?? 0;
//   const totalBacklinks  = daData?.total_backlinks  ?? 0;
//   const referringDomains = daData?.referring_domains ?? 0;

//   // ── Page Speed ─────────────────────────────────────────────────────────
//   const psData    = loadCached(`pageSpeedRaw_${domain}`);
//   const mobilePerf = psData?.mobile?.performance_score ?? 0;
//   const desktopPerf = psData?.desktop?.performance_score ?? 0;

//   // ── Technical SEO ──────────────────────────────────────────────────────
//   const tech = loadCached(`technicalSEO_${domain}`) || {};
//   const techChecks = [
//     tech.ssl_status?.status === 'Secure',
//     tech.robots_txt?.status === 'Present',
//     tech.sitemap?.status === 'Present',
//     tech.google_analytics?.detected,
//     tech.google_tag_manager?.detected,
//     tech.meta_pixel?.detected,
//     tech.mobile_usability?.status === 'Pass',
//     tech.core_web_vitals?.status === 'Pass',
//     (tech.schema_markup_types?.count || 0) > 0,
//     (tech.meta_title_issues?.count || 0) === 0,
//     (tech.alt_coverage || 0) >= 70,
//     tech.canonical_tags?.status === 'Present',
//     (tech.broken_links || 0) === 0,
//   ];
//   const passCount  = techChecks.filter(Boolean).length;
//   const totalCount = techChecks.length;
//   const techScore  = Math.round((passCount / totalCount) * 100);

//   // ── GMB ────────────────────────────────────────────────────────────────
//   // GMBProfile.jsx stores raw brandData under:
//   //   key = `gmbBrand_${cleanedDomain || placeId || gmbLink}_${location || 'noloc'}`
//   //   value = { timestamp, data: brandData }   ← { timestamp } not { ts }
//   // Rating path in raw brandData: data.reviews?.value?.rating ?? data.reviews?.rating
//   const gmbLocationKey = location || 'noloc';
//   const gmbCacheKey    = `gmbBrand_${domain || placeId || gmbLink}_${gmbLocationKey}`;
//   const gmbRaw         = loadCached(gmbCacheKey) || {}; // loadCached uses { timestamp, data }
//   // Extract using exact same logic as GMBProfile normalizeApiData
//   const gmbRating  = gmbRaw.reviews?.value?.rating ?? gmbRaw.reviews?.rating  ?? 0;
//   const gmbReviews = gmbRaw.reviews?.value?.count  ?? gmbRaw.reviews?.count   ?? 0;


// // ── AI Visibility ──────────────────────────────────────────────────────
// let aiAvg = 0;
// if (pillarKeywords.length) {
//   const brandSlug = brandName.toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20);
//   for (const kw of pillarKeywords) {
//     // Try both possible key formats (with slug first, then without)
//     const keysToTry = [
//       `aiVisibility_${domain}_${brandSlug}_${kw}`,
//       `aiVisibility_${domain}_${kw}`
//     ];
//     let aiCache = null;
//     for (const key of keysToTry) {
//       aiCache = loadCached(key);
//       if (aiCache) break;
//     }
//     if (aiCache) {
//       // The stored object shape: { summary: { aiVisibilityScore, ... }, platforms, ... }
//       let score = 0;
//       if (aiCache.summary?.aiVisibilityScore !== undefined) {
//         score = aiCache.summary.aiVisibilityScore;
//       } else if (aiCache.summary?.brand_avg_score !== undefined) {
//         score = aiCache.summary.brand_avg_score;
//       } else if (aiCache.aiVisibilityScore !== undefined) {
//         score = aiCache.aiVisibilityScore;
//       } else if (typeof aiCache === 'number') {
//         score = aiCache;
//       } else if (aiCache.overallScore !== undefined) {
//         score = aiCache.overallScore;
//       } else if (aiCache.score !== undefined) {
//         score = aiCache.score;
//       } else if (aiCache.summary && typeof aiCache.summary === 'object') {
//         // Fallback: try to find any numeric score field
//         const possible = ['aiVisibilityScore', 'brand_avg_score', 'avg_score', 'overallScore'];
//         for (const f of possible) {
//           if (typeof aiCache.summary[f] === 'number') {
//             score = aiCache.summary[f];
//             break;
//           }
//         }
//       }

//       if (score > 0) {
//         aiAvg = Math.round(score);
//         break; // Use first keyword with a valid score
//       }
//     }
//   }
// }
// // If still zero, you might want to fall back to a global AI visibility cache (if any)


//   // ── Critical failures list ─────────────────────────────────────────────
//   const failures = [];
//   if (tech.ssl_status?.status !== 'Secure')           failures.push('HTTPS not secure');
//   if (!tech.google_analytics?.detected)               failures.push('GA4 tracking missing');
//   if (!tech.meta_pixel?.detected)                     failures.push('Meta Pixel missing');
//   if ((tech.meta_title_issues?.count || 0) > 0)       failures.push(`${tech.meta_title_issues.count} meta title issue(s)`);
//   if ((tech.broken_links || 0) > 0)                   failures.push(`${tech.broken_links} broken link(s)`);
//   if (tech.mobile_usability?.status !== 'Pass')        failures.push('Mobile usability issues');
//   if (tech.core_web_vitals?.status !== 'Pass')         failures.push('Core Web Vitals failing');
//   if (!tech.sitemap?.status?.includes('Present'))      failures.push('Sitemap missing');
//   if ((tech.schema_markup_types?.count || 0) === 0)   failures.push('No schema markup');
//   const criticalText = failures.length ? failures.join(', ') : 'No critical failures found';

//   // ── Strengths ──────────────────────────────────────────────────────────
//   const strengths = [];
//   if (domainAuthority >= 40)  strengths.push(`Strong domain authority (${domainAuthority}/100)`);
//   if (mobilePerf >= 70)       strengths.push(`Fast mobile speed (${mobilePerf}/100)`);
//   if (gmbRating >= 4.5)       strengths.push(`Excellent Google rating (${gmbRating}⭐ from ${gmbReviews} reviews)`);
//   if (aiAvg >= 50)            strengths.push(`Good AI visibility (${aiAvg}/100)`);
//   if (techScore >= 77)        strengths.push(`Strong technical health (${passCount}/${totalCount} checks passed)`);
//   if (totalBacklinks > 500)   strengths.push(`${totalBacklinks.toLocaleString()} backlinks`);
//   if (gmbReviews >= 50)       strengths.push(`${gmbReviews} Google reviews`);
//   const strengthsText = strengths.length ? strengths.join(', ') : 'No clear strengths identified — all areas need attention';

//   // ── Weakest area (normalised 0–100) ───────────────────────────────────
//   const dimensionScores = {
//     'Domain Authority':  domainAuthority,
//     'Mobile Page Speed': mobilePerf,
//     'AI Visibility':     aiAvg,
//     'GMB Rating':        gmbRating > 0 ? Math.round((gmbRating / 5) * 100) : 0,
//     'Technical Health':  techScore,
//   };
//   const [weakestName, weakestScore] = Object.entries(dimensionScores)
//     .reduce((a, b) => a[1] < b[1] ? a : b);
//   const weakestText = `${weakestName} (${weakestScore}/100)`;

//   // ── Top competitor data ────────────────────────────────────────────────
//   let topCompName = '', compDA = 0, compPerf = 0, compScore = 0, compGmbRating = 0;
//   if (competitorsList.length) {
//     const comp       = competitorsList[0];
//     topCompName      = comp.name || cleanDomain(comp.website) || 'a competitor';
//     compGmbRating    = comp.rating || 0;
//     const compDomain = cleanDomain(comp.website);
//     if (compDomain) {
//       const compDAData  = loadDACached(`domainAuthority_${compDomain}`);
//       compDA            = compDAData?.domain_authority ?? 0;
//       const compPSData  = loadCached(`pageSpeedRaw_${compDomain}`);
//       compPerf          = compPSData?.mobile?.performance_score ?? 0;
//       const compSCache  = loadCached(`overallScore_${compDomain}`);
//       compScore         = compSCache?.overallScore ?? 0;
//     }
//   }

//   // ── Score label ────────────────────────────────────────────────────────
//   const scoreLabel =
//     overallScore >= 80 ? 'Excellent'   :
//     overallScore >= 65 ? 'Strong'      :
//     overallScore >= 45 ? 'Developing'  : 'Needs Work';

//   // ── Competitor comparison line ─────────────────────────────────────────
//   const compLines = [];
//   if (compScore)       compLines.push(`Overall Score: ${compScore}/100`);
//   if (compDA)          compLines.push(`Domain Authority: ${compDA}/100`);
//   if (compPerf)        compLines.push(`Mobile Speed: ${compPerf}/100`);
//   if (compGmbRating)   compLines.push(`Google Rating: ${compGmbRating}⭐`);
//   const compSummary = compLines.length ? compLines.join(' | ') : 'Data not available';

//   // ── Build the prompt ───────────────────────────────────────────────────
//   const prompt = `You are a trusted digital marketing advisor who has just completed a full brand audit for ${brandName}. You are now speaking directly to the business owner, delivering your honest verdict.

// Speak to them personally — use "your" and "you". Be warm, honest, and direct. Sound like a real person who cares, not a consultant writing a report.

// RULES:
// - No bullet points or numbered lists
// - No jargon. No words like: leverage, synergy, holistic, robust, actionable, comprehensive, utilise, pivotal
// - Exactly 3 paragraphs. Each paragraph is 2–3 sentences. Total word count: 90–120 words
// - Every paragraph must reference at least one specific number from the data below
// - The final sentence should feel like genuine, warm advice from someone who wants them to win

// BRAND: ${brandName}
// INDUSTRY: ${industry || 'local business / services'}
// LOCATION: ${location || 'India'}

// THEIR AUDIT RESULTS:
// - Overall Brand Score: ${overallScore}/100 (${scoreLabel})
// - Domain Authority: ${domainAuthority}/100 (backlinks: ${totalBacklinks.toLocaleString()}, referring domains: ${referringDomains})
// - Mobile Page Speed: ${mobilePerf}/100 | Desktop: ${desktopPerf}/100
// - Technical Health: ${passCount} of ${totalCount} checks passed (${techScore}%)
// - AI Visibility: ${aiAvg}/100 (how often AI tools like Gemini, ChatGPT recommend them)
// - Google Rating: ${gmbRating} stars from ${gmbReviews} reviews

// MAIN COMPETITOR: ${topCompName || 'their main competitor'}
// ${compSummary}

// WHAT IS BROKEN:
// ${criticalText}

// WHAT IS WORKING:
// ${strengthsText}

// SINGLE WEAKEST DIMENSION:
// ${weakestText}

// NOW WRITE THE 3 PARAGRAPHS:

// Paragraph 1 — Their honest current position. Reference the overall score (${overallScore}/100). Name one specific strength and one specific problem. Make them feel seen, not judged.

// Paragraph 2 — The competitor reality. Compare them directly to ${topCompName || 'their main competitor'}. Who is winning right now and by how much? What does that gap actually mean when a customer is choosing between the two?

// Paragraph 3 — The single most urgent fix: ${weakestName}. Tell them in plain terms what changes for their business in the next 30 days if they fix it, and what quietly keeps costing them if they don't. End with one warm, human sentence of encouragement.`;

//   return {
//     brandName, domain, websiteUrl, location, industry,
//     overallScore, scoreLabel, domainAuthority, mobilePerf, desktopPerf,
//     techScore, passCount, totalCount,
//     aiAvg, gmbRating, gmbReviews,
//     topCompName, compDA, compPerf, compScore,
//     strengthsText, criticalText, weakestName, weakestScore, weakestText,
//     dimensionScores, prompt,
//   };
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Score Pill
// // ─────────────────────────────────────────────────────────────────────────
// const ScorePill = ({ value, label, thresholds = [70, 45] }) => {
//   const color =
//     value >= thresholds[0] ? '#0D9488' :
//     value >= thresholds[1] ? '#C47D1A' : '#C0392B';
//   return (
//     <div className="fscore-pill">
//       <span className="fscore-pill-val" style={{ color }}>{value}</span>
//       <span className="fscore-pill-lbl">{label}</span>
//     </div>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Verdict Box with TTS
// // ─────────────────────────────────────────────────────────────────────────
// // ─────────────────────────────────────────────────────────────────────────
// // Verdict Box with single Play/Pause toggle
// // ─────────────────────────────────────────────────────────────────────────
// const VerdictBox = ({ text, loading, error, onRegenerate }) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isPaused, setIsPaused] = useState(false);
//   const utteranceRef = useRef(null);

//   // Cancel speech on unmount
//   useEffect(() => {
//     return () => window.speechSynthesis.cancel();
//   }, []);

//   // Single toggle: Play / Pause
//   const togglePlayback = () => {
//     const synth = window.speechSynthesis;

//     if (isPlaying) {
//       // Currently playing → pause
//       synth.pause();
//       setIsPlaying(false);
//       setIsPaused(true);
//     } else {
//       // Not playing → either resume or start fresh
//       if (isPaused && synth.paused) {
//         synth.resume();
//         setIsPlaying(true);
//         setIsPaused(false);
//       } else {
//         // Cancel anything and start new
//         synth.cancel();
//         const utterance = new SpeechSynthesisUtterance(text.replace(/<[^>]*>/g, ''));
//         utterance.lang = 'en-IN';
//         utterance.onend = () => {
//           setIsPlaying(false);
//           setIsPaused(false);
//         };
//         utterance.onerror = () => {
//           setIsPlaying(false);
//           setIsPaused(false);
//         };
//         utteranceRef.current = utterance;
//         synth.speak(utterance);
//         setIsPlaying(true);
//         setIsPaused(false);
//       }
//     }
//   };

//   return (
//     <div className="verdict-box">
//       <div className="verdict-header">
//         <span className="verdict-label">Performance Summary</span>

//         <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
//           {/* Single Play/Pause toggle button – only when text is ready */}
//           {text && !loading && (
//             <button className="play-btn" onClick={togglePlayback}>
//               <svg viewBox="0 0 24 24" width="12" height="12">
//                 {isPlaying ? (
//                   <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" /> // Pause icon
//                 ) : (
//                   <path d="M8 5v14l11-7z" /> // Play icon
//                 )}
//               </svg>
//               {isPlaying ? 'Pause' : 'Play'}
//             </button>
//           )}
//           {/* (Regenerate button is optional – you can uncomment if needed) */}
//         </div>
//       </div>

//       {/* States */}
//       {loading && (
//         <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: '#6B4FA0', padding: '12px 0' }}>
//           <div className="spinner" style={{ width: 16, height: 16, borderTopColor: '#6B4FA0' }} />
//           Generating your AI Insight…
//         </div>
//       )}
//       {error && !loading && (
//         <div style={{ fontSize: 12, color: '#c62828', padding: '8px 0' }}>
//           {error}{' '}
//           <button onClick={onRegenerate} style={{ color: '#6B4FA0', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', fontSize: 12 }}>
//             Try again
//           </button>
//         </div>
//       )}
//       {text && !loading && (
//         <div className="verdict-text" style={{ marginTop: 10, lineHeight: 1.75, fontSize: 14, color: '#1C1626', whiteSpace: 'pre-line' }}>
//           {text}
//         </div>
//       )}
//       {!text && !loading && !error && (
//         <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic', padding: '8px 0' }}>
//           Your final AI-powered verdict will appear here shortly.
//         </div>
//       )}
//     </div>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Dimension breakdown bar
// // ─────────────────────────────────────────────────────────────────────────
// const DimensionBar = ({ label, score, thresholds = [70, 45] }) => {
//   const color =
//     score >= thresholds[0] ? '#0D9488' :
//     score >= thresholds[1] ? '#C47D1A' : '#C0392B';
//   return (
//     <div style={{ marginBottom: 10 }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
//         <span style={{ color: '#555', fontWeight: 500 }}>{label}</span>
//         <span style={{ color, fontWeight: 700 }}>{score}/100</span>
//       </div>
//       <div style={{ height: 6, borderRadius: 99, background: '#f0edf7', overflow: 'hidden' }}>
//         <div style={{
//           height: '100%', borderRadius: 99,
//           width: `${Math.min(score, 100)}%`,
//           background: color,
//           transition: 'width 1s ease',
//         }} />
//       </div>
//     </div>
//   );
// };

// // ─────────────────────────────────────────────────────────────────────────
// // Main Component
// // ─────────────────────────────────────────────────────────────────────────
// const FinalVerdict = () => {
//   const [data,    setData]    = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [verdict, setVerdict] = useState('');
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError,   setAiError]   = useState('');
//   const cacheKeyRef = useRef('');

//   // ── Load audit data ────────────────────────────────────────────────────
//   useEffect(() => {
//     let settled = false;
//     let interval;

//     const tryLoad = () => {
//       if (settled) return;
//       const audit = buildAuditData();
//       // Consider data ready if we have at least one real score
//       const hasData = audit.domainAuthority > 0 || audit.mobilePerf > 0 || audit.overallScore > 0;
//       if (hasData) {
//         settled = true;
//         clearInterval(interval);
//         finalise(audit);
//       }
//     };

//     const finalise = (audit) => {
//       setData(audit);
//       setLoading(false);
//       const key = `final_verdict_${audit.domain}`;
//       cacheKeyRef.current = key;
//       // Try cache first
//       const cached = loadAICached(key);
//       if (cached) {
//         setVerdict(cached);
//       } else {
//         generateVerdict(audit.prompt, key);
//       }
//     };

//     tryLoad();
//     interval = setInterval(tryLoad, 600);

//     // Hard timeout — load whatever we have
//     const timeout = setTimeout(() => {
//       if (!settled) {
//         clearInterval(interval);
//         const audit = buildAuditData();
//         finalise(audit);
//       }
//     }, 12000);

//     return () => { clearInterval(interval); clearTimeout(timeout); };
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // ── Generate verdict ───────────────────────────────────────────────────
//   const generateVerdict = useCallback(async (prompt, cacheKey) => {
//     if (!prompt) return;
//     setAiLoading(true);
//     setAiError('');
//     setVerdict('');
//     try {
//       const text = await callGemini(prompt);
//       setVerdict(text);
//       saveAICache(cacheKey || cacheKeyRef.current, text);
//     } catch (e) {
//       console.error('Gemini verdict error:', e);
//       setAiError('Could not generate the verdict. Please check your Gemini API key.');
//     } finally {
//       setAiLoading(false);
//     }
//   }, []);

//   const handleRegenerate = () => {
//     if (data) {
//       // Bust the cache so we get a fresh response
//       try { localStorage.removeItem(cacheKeyRef.current); } catch {}
//       generateVerdict(data.prompt, cacheKeyRef.current);
//     }
//   };

//   const handleDownloadPDF = () => {
//     const orig = document.title;
//     const safe = data?.brandName?.replace(/[^a-z0-9]/gi, '_').substring(0, 30) || 'brand';
//     const date = new Date().toLocaleDateString('en-CA');
//     document.title = `${safe}_Audit_${date}`;
//     window.print();
//     setTimeout(() => { document.title = orig; }, 1000);
//   };

//   // ── Loading state ──────────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <div className="card" id="card-done">
//         <div className="final-card-inner">
//           <div style={{ textAlign: 'center', padding: '40px' }}>
//             <div className="spinner" style={{ margin: '0 auto 16px' }} />
//             <div style={{ fontSize: 14, color: '#6B4FA0' }}>Loading final audit data…</div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!data) return null;

//   const {
//     brandName, overallScore, scoreLabel,
//     domainAuthority, mobilePerf, techScore, passCount, totalCount,
//     aiAvg, gmbRating, gmbReviews,
//     topCompName, compDA, compPerf, compScore,
//     dimensionScores,
//   } = data;

//   // ── Dynamic headline ───────────────────────────────────────────────────
//   const [weakDim] = Object.entries(dimensionScores).reduce((a, b) => a[1] < b[1] ? a : b);

//   let dynamicTitle = '', dynamicSubtitle = '';
//   if (overallScore >= 75) {
//     dynamicTitle    = `<strong>${brandName}</strong> — you're doing well. <em>Don't get comfortable.</em>`;
//     dynamicSubtitle = `A score of ${overallScore}/100 is solid. But your ${weakDim} is a gap competitors could exploit.`;
//   } else if (overallScore >= 50) {
//     dynamicTitle    = `<strong>${brandName}</strong> has real potential. <em>It's just buried right now.</em>`;
//     dynamicSubtitle = `You're sitting at ${overallScore}/100. Your ${weakDim} is what's holding everything back.`;
//   } else {
//     dynamicTitle    = `<strong>${brandName}</strong>, the market doesn't know you exist. <em>Yet.</em>`;
//     dynamicSubtitle = `A score of ${overallScore}/100 means there's a lot of ground to cover — and a lot of quick wins waiting.`;
//   }

//   const today = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

//   return (
//     <div className="card" id="card-done">
//       <div className="final-card-inner">

//         {/* ── Eyebrow ── */}
//         <div className="final-eyebrow">Audit Complete</div>

//         {/* ── Headline ── */}
//         <h2 className="final-title" dangerouslySetInnerHTML={{ __html: dynamicTitle }} />
//         <p className="final-subtitle">{dynamicSubtitle}</p>

//         {/* ── Score Strip ── */}
//         {/* <div className="final-score-strip">
//           <ScorePill value={overallScore}    label="Brand Score"   thresholds={[70, 45]} />
//           <div className="fscore-divider" />
//           <ScorePill value={domainAuthority} label="Domain Auth"   thresholds={[40, 25]} />
//           <div className="fscore-divider" />
//           <ScorePill value={mobilePerf}      label="Page Speed"    thresholds={[70, 50]} />
//           <div className="fscore-divider" />
//           <ScorePill value={techScore}       label="Technical"     thresholds={[77, 50]} />
//           <div className="fscore-divider" />
//           <ScorePill value={aiAvg} label="AI Visibility" thresholds={[60, 30]} fullWidth: true  />
//         </div> */}

//        {/* ── Score Cards ── */}
//         {[
//           {
//             label:     'Brand Score',
//             // sub:       overallScore >= 70 ? 'Strong brand recognition and visibility.'
//             //           : overallScore >= 45 ? 'Growing presence, room to improve.'
//             //           : 'Low brand recognition and market presence.',
//             value:     overallScore,
//             threshold: [70, 45],
//             icon: <path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"/>,
//             bgLight: '#FAECE7', iconColor: '#D85A30',
//           },
//           {
//             label:     'Domain Authority',
//             // sub:       domainAuthority >= 40 ? 'Good trust signals for search engines.'
//             //           : domainAuthority >= 25 ? 'Building authority, keep growing backlinks.'
//             //           : "Search engines don't trust you enough yet.",
//             value:     domainAuthority,
//             threshold: [40, 25],
//             icon: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>,
//             bgLight: '#FAEEDA', iconColor: '#BA7517',
//           },
//           {
//             label:     'Page Speed',
//             // sub:       mobilePerf >= 70 ? 'Fast loading — great user experience.'
//             //           : mobilePerf >= 50 ? 'Average speed, some optimisation needed.'
//             //           : 'Needs optimization for better user experience.',
//             value:     mobilePerf,
//             threshold: [70, 50],
//             icon: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>,
//             bgLight: '#FAEEDA', iconColor: '#BA7517',
//           },
//           {
//             label:     'Site Performance',
//             // sub:       techScore >= 77 ? 'Strong technical foundation.'
//             //           : techScore >= 50 ? 'Decent foundation, but room to improve.'
//             //           : 'Critical technical issues need attention.',
//             value:     techScore,
//             threshold: [77, 50],
//             icon: <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>,
//             bgLight: '#EAF3DE', iconColor: '#639922',
//           },
//           {
//             label:     'AI Visibility',
//             // sub:       aiAvg >= 60 ? 'AI tools are recommending you.'
//             //           : aiAvg >= 30 ? 'Partial AI visibility — growing presence.'
//             //           : "You're invisible to AI platforms right now.",
//             value:     aiAvg,
//             threshold: [60, 30],
//             icon: <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM9 14.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5.5 3.5h-5v-2h5v2zm.5-3.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>,
//             bgLight: '#EEEDFE', iconColor: '#534AB7',
//           },
//         ].map(({ label, sub, value, threshold, icon, bgLight, iconColor }) => {
//           const color = value >= threshold[0] ? '#0D9488'
//                       : value >= threshold[1] ? '#C47D1A' : '#C0392B';
//           return (
//             <div key={label} style={{
//               display: 'flex', alignItems: 'center', gap: 14,
//               background: 'rgba(255,255,255,0.7)',
//               border: '1px solid rgba(107,79,160,0.1)',
//               borderRadius: 14, padding: '14px 18px',
//               marginBottom: 10,
//               backdropFilter: 'blur(8px)',
//             }}>
//               {/* Icon */}
//               <div style={{
//                 width: 44, height: 44, borderRadius: 10,
//                 background: bgLight,
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 flexShrink: 0,
//               }}>
//                 <svg viewBox="0 0 24 24" width="22" height="22" fill={iconColor}>
//                   {icon}
//                 </svg>
//               </div>

//               {/* Label + subtitle + bar */}
//               <div style={{ flex: 1, minWidth: 0 }}>
//                 <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--ink)', marginBottom: 2 }}>
//                   {label}
//                 </div>
//                 <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8 }}>
//                   {sub}
//                 </div>
//                 <div style={{ height: 4, borderRadius: 99, background: 'rgba(107,79,160,0.1)', overflow: 'hidden' }}>
//                   <div style={{
//                     height: '100%', borderRadius: 99,
//                     width: `${Math.min(value, 100)}%`,
//                     background: color,
//                     transition: 'width 1s ease',
//                   }} />
//                 </div>
//               </div>

//               {/* Score */}
//               <div style={{ textAlign: 'right', flexShrink: 0, paddingLeft: 12 }}>
//                 <div style={{ fontSize: 26, fontWeight: 700, color, lineHeight: 1, fontFamily: '"Fraunces", serif' }}>
//                   {value}
//                 </div>
//                 <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>/100</div>
//               </div>
//             </div>
//           );
//         })}
//         {/* ── Dimension Breakdown ── */}
//         {/* <div style={{
//           background: '#faf9fd',
//           borderRadius: 14,
//           padding: '18px 20px',
//           marginBottom: 20,
//           VerdictBox border: '1px solid rgba(107,79,160,0.1)',
//         }}>
//           <div style={{ fontSize: 11, fontWeight: 700, color: '#6B4FA0', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 14 }}>
//             Score Breakdown
//           </div>
//           {Object.entries(dimensionScores).map(([label, score]) => (
//             <DimensionBar key={label} label={label} score={score} />
//           ))}
//         </div> */}

//         {/* ── Competitor Snapshot (only if data exists) ── */}
//         {/* {topCompName && (compDA > 0 || compPerf > 0 || compScore > 0) && (
//           <div style={{
//             background: '#fff8f0',
//             borderRadius: 14,
//             padding: '14px 18px',
//             marginBottom: 20,
//             border: '1px solid rgba(196,125,26,0.18)',
//             display: 'flex',
//             flexWrap: 'wrap',
//             gap: 16,
//             alignItems: 'center',
//           }}>
//             <div style={{ fontSize: 11, fontWeight: 700, color: '#C47D1A', textTransform: 'uppercase', letterSpacing: '0.08em', flexBasis: '100%' }}>
//               vs {topCompName}
//             </div>
//             {compScore > 0 && (
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ fontSize: 20, fontWeight: 800, color: compScore > overallScore ? '#C0392B' : '#0D9488' }}>{compScore}</div>
//                 <div style={{ fontSize: 11, color: '#888' }}>Brand Score</div>
//               </div>
//             )}
//             {compDA > 0 && (
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ fontSize: 20, fontWeight: 800, color: compDA > domainAuthority ? '#C0392B' : '#0D9488' }}>{compDA}</div>
//                 <div style={{ fontSize: 11, color: '#888' }}>Domain Auth</div>
//               </div>
//             )}
//             {compPerf > 0 && (
//               <div style={{ textAlign: 'center' }}>
//                 <div style={{ fontSize: 20, fontWeight: 800, color: compPerf > mobilePerf ? '#C0392B' : '#0D9488' }}>{compPerf}</div>
//                 <div style={{ fontSize: 11, color: '#888' }}>Mobile Speed</div>
//               </div>
//             )}
//             <div style={{ fontSize: 11, color: '#888', fontStyle: 'italic', flexBasis: '100%' }}>
//               Red = competitor leads | Green = you lead
//             </div>
//           </div>
//         )} */}

//         {/* ── AI Verdict ── */}
//         <VerdictBox
//           text={verdict}
//           loading={aiLoading}
//           error={aiError}
//           onRegenerate={handleRegenerate}
//         />

//         {/* ── GMB snapshot ── */}
//         {/* {(gmbRating > 0 || gmbReviews > 0) && (
//           <div style={{
//             display: 'flex', gap: 16, alignItems: 'center',
//             background: '#f0fdf4', borderRadius: 12, padding: '12px 16px',
//             border: '1px solid rgba(13,148,136,0.15)', marginTop: 16,
//           }}>
//             <span style={{ fontSize: 24 }}>⭐</span>
//             <div>
//               <div style={{ fontWeight: 700, fontSize: 15, color: '#0D9488' }}>
//                 {gmbRating} stars
//               </div>
//               <div style={{ fontSize: 12, color: '#555' }}>
//                 {gmbReviews} Google reviews
//               </div>
//             </div>
//           </div>
//         )} */}

//         {/* ── Sign-off ── */}
//         <div className="final-signoff" style={{ marginTop: 24 }}>
//           {/* <div className="signoff-logo">
//             <svg viewBox="0 0 24 24"><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z"/></svg>
//           </div> */}
//           <div className="signoff-text">
//             Brand Audit Report
//             <br />Generated on {today}
//             {/* <button
//               onClick={handleDownloadPDF}
//               style={{
//                 marginLeft: 12, fontSize: 11, padding: '4px 10px',
//                 background: '#6B4FA0', color: '#fff', border: 'none',
//                 borderRadius: 6, cursor: 'pointer', fontWeight: 600,
//               }}
//             >
//               📄 Download PDF
//             </button> */}
           
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default FinalVerdict;
// src/components/BrandAudit/Step10_FinalVerdict.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { GoogleGenerativeAI } from '@google/generative-ai';
import { computeOverallScore } from '../../utils/scoreUtils';

// ─────────────────────────────────────────────────────────────────────────
// Constants
// ─────────────────────────────────────────────────────────────────────────
const CACHE_TTL     = 24 * 60 * 60 * 1000; // 24h for audit data
const VERDICT_TTL   = 24 * 60 * 60 * 1000; // 24h for AI verdict
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || '';

// ─────────────────────────────────────────────────────────────────────────
// Helpers
// ─────────────────────────────────────────────────────────────────────────
const cleanDomain = (url) =>
  url?.replace(/^https?:\/\//, '').replace(/^www\./, '').split('/')[0].toLowerCase().trim() || '';

const loadCached = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { timestamp, data } = JSON.parse(raw);
    return Date.now() - timestamp < CACHE_TTL ? data : null;
  } catch { return null; }
};

const loadDACached = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { ts, d } = JSON.parse(raw);
    return Date.now() - ts < CACHE_TTL ? d : null;
  } catch { return null; }
};

const loadAICached = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { ts, text } = JSON.parse(raw);
    return Date.now() - ts < VERDICT_TTL ? text : null;
  } catch { return null; }
};

const saveAICache = (key, text) => {
  try {
    localStorage.setItem(key, JSON.stringify({ ts: Date.now(), text }));
  } catch {}
};

// ── Extract a usable numeric AI-visibility score out of whatever shape
//    the cached payload happens to be in (defensive against schema drift) ──
const extractAiScore = (aiCache) => {
  if (!aiCache) return 0;
  if (typeof aiCache === 'number') return aiCache;

  if (aiCache.summary?.aiVisibilityScore !== undefined) return aiCache.summary.aiVisibilityScore;
  if (aiCache.summary?.brand_avg_score !== undefined) return aiCache.summary.brand_avg_score;
  if (aiCache.aiVisibilityScore !== undefined) return aiCache.aiVisibilityScore;
  if (aiCache.overallScore !== undefined) return aiCache.overallScore;
  if (aiCache.score !== undefined) return aiCache.score;

  if (aiCache.summary && typeof aiCache.summary === 'object') {
    const possible = ['aiVisibilityScore', 'brand_avg_score', 'avg_score', 'overallScore'];
    for (const f of possible) {
      if (typeof aiCache.summary[f] === 'number') return aiCache.summary[f];
    }
  }
  return 0;
};

// ── Find the AI Visibility cache Step9 actually wrote ──────────────────────
// Step9 (Step9_AIVisibility.jsx) writes ONE shared-pool cache entry keyed by
// ALL tracked keywords joined together — NOT one entry per keyword:
//
//   const brandSlug = brandName.toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20);
//   const kwSlug = pillarKeywords.slice(0, 5).join('|').toLowerCase().replace(/[^a-z0-9|]/g, '');
//   const cacheKey = `aiVisibility_${domain}_${brandSlug}_${kwSlug}`;
//
// so we must build that exact same combined key here — looping per-keyword
// (the old per-keyword cache scheme) will never find it. We also scan for
// any `aiVisibility_${domain}_*` entry as a fallback in case brand/keyword
// casing or ordering ever drifts between the two steps.
const findAiVisibilityScore = (domain, brandName, pillarKeywords) => {
  if (!domain) return 0;

  const brandSlug = (brandName || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20);
  const kwSlug = (pillarKeywords || [])
    .slice(0, 5)
    .join('|')
    .toLowerCase()
    .replace(/[^a-z0-9|]/g, '');

  const exactKey = `aiVisibility_${domain}_${brandSlug}_${kwSlug}`;
  const exactCache = loadCached(exactKey);
  const exactScore = extractAiScore(exactCache);
  if (exactScore > 0) return Math.round(exactScore);

  // ── Fallback: scan localStorage for any matching, non-expired entry ──
  try {
    const prefix = `aiVisibility_${domain}_`;
    let best = null;
    let bestTimestamp = 0;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(prefix)) continue;
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      try {
        const { timestamp, data } = JSON.parse(raw);
        if (!timestamp || Date.now() - timestamp >= CACHE_TTL) continue;
        const score = extractAiScore(data);
        if (score > 0 && timestamp > bestTimestamp) {
          best = score;
          bestTimestamp = timestamp;
        }
      } catch { /* skip malformed entry */ }
    }
    if (best) return Math.round(best);
  } catch { /* localStorage unavailable */ }

  return 0;
};

// ─────────────────────────────────────────────────────────────────────────
// Gemini caller
// ─────────────────────────────────────────────────────────────────────────
const genAI = GEMINI_API_KEY ? new GoogleGenerativeAI(GEMINI_API_KEY) : null;

const callGemini = async (prompt) => {
  if (!genAI) throw new Error('REACT_APP_GEMINI_API_KEY not set');
  const model  = genAI.getGenerativeModel({ model: 'gemini-2.5-flash' });
  const result = await model.generateContent(prompt);
  return result.response.text();
};

// ─────────────────────────────────────────────────────────────────────────
// Data aggregation — single source of truth
// ─────────────────────────────────────────────────────────────────────────
const buildAuditData = () => {
  // ── Form data ──────────────────────────────────────────────────────────
  let brandName = '', websiteUrl = '', location = '',
      pillarKeywords = [], industry = '', gmbLink = '', placeId = '';
  try {
    const fd = JSON.parse(localStorage.getItem('auditFormData') || '{}');
    brandName      = fd.brandName      || '';
    websiteUrl     = fd.websiteUrl     || '';
    location       = fd.locations?.[0]?.city    || '';
    gmbLink        = fd.locations?.[0]?.gmbLink || '';
    pillarKeywords = fd.pillarKeywords || [];
    industry       = fd.industry       || '';
  } catch {}
  // placeId is persisted in lastAuditInfo by BrandAuditWizard
  try {
    const ai = JSON.parse(localStorage.getItem('lastAuditInfo') || '{}');
    placeId = ai.placeId || '';
  } catch {}

  const domain = cleanDomain(websiteUrl) || brandName.toLowerCase().replace(/\s/g, '');

  // ── Competitors ────────────────────────────────────────────────────────
  let competitorsList = [];
  try { competitorsList = JSON.parse(localStorage.getItem('competitors_list') || '[]'); } catch {}

  // ── Overall score ──────────────────────────────────────────────────────
  const scoreCache  = loadCached(`overallScore_${domain}`);
  const overallScore = scoreCache?.overallScore ?? 0;

  // ── Domain Authority ───────────────────────────────────────────────────
  const daData          = loadDACached(`domainAuthority_${domain}`);
  const domainAuthority = daData?.domain_authority ?? 0;
  const totalBacklinks  = daData?.total_backlinks  ?? 0;
  const referringDomains = daData?.referring_domains ?? 0;

  // ── Page Speed ─────────────────────────────────────────────────────────
  const psData    = loadCached(`pageSpeedRaw_${domain}`);
  const mobilePerf = psData?.mobile?.performance_score ?? 0;
  const desktopPerf = psData?.desktop?.performance_score ?? 0;

  // ── Technical SEO ──────────────────────────────────────────────────────
  const tech = loadCached(`technicalSEO_${domain}`) || {};
  const techChecks = [
    tech.ssl_status?.status === 'Secure',
    tech.robots_txt?.status === 'Present',
    tech.sitemap?.status === 'Present',
    tech.google_analytics?.detected,
    tech.google_tag_manager?.detected,
    tech.meta_pixel?.detected,
    tech.mobile_usability?.status === 'Pass',
    tech.core_web_vitals?.status === 'Pass',
    (tech.schema_markup_types?.count || 0) > 0,
    (tech.meta_title_issues?.count || 0) === 0,
    (tech.alt_coverage || 0) >= 70,
    tech.canonical_tags?.status === 'Present',
    (tech.broken_links || 0) === 0,
  ];
  const passCount  = techChecks.filter(Boolean).length;
  const totalCount = techChecks.length;
  const techScore  = Math.round((passCount / totalCount) * 100);

  // ── GMB ────────────────────────────────────────────────────────────────
  // GMBProfile.jsx stores raw brandData under:
  //   key = `gmbBrand_${cleanedDomain || placeId || gmbLink}_${location || 'noloc'}`
  //   value = { timestamp, data: brandData }   ← { timestamp } not { ts }
  // Rating path in raw brandData: data.reviews?.value?.rating ?? data.reviews?.rating
  const gmbLocationKey = location || 'noloc';
  const gmbCacheKey    = `gmbBrand_${domain || placeId || gmbLink}_${gmbLocationKey}`;
  const gmbRaw         = loadCached(gmbCacheKey) || {}; // loadCached uses { timestamp, data }
  // Extract using exact same logic as GMBProfile normalizeApiData
  const gmbRating  = gmbRaw.reviews?.value?.rating ?? gmbRaw.reviews?.rating  ?? 0;
  const gmbReviews = gmbRaw.reviews?.value?.count  ?? gmbRaw.reviews?.count   ?? 0;

  // ── AI Visibility ──────────────────────────────────────────────────────
  // See findAiVisibilityScore() — must use the SAME combined cache key
  // Step9_AIVisibility.jsx writes (one shared-pool entry across all
  // keywords), not a per-keyword key.
  const aiAvg = findAiVisibilityScore(domain, brandName, pillarKeywords);

  // ── Critical failures list ─────────────────────────────────────────────
  const failures = [];
  if (tech.ssl_status?.status !== 'Secure')           failures.push('HTTPS not secure');
  if (!tech.google_analytics?.detected)               failures.push('GA4 tracking missing');
  if (!tech.meta_pixel?.detected)                     failures.push('Meta Pixel missing');
  if ((tech.meta_title_issues?.count || 0) > 0)       failures.push(`${tech.meta_title_issues.count} meta title issue(s)`);
  if ((tech.broken_links || 0) > 0)                   failures.push(`${tech.broken_links} broken link(s)`);
  if (tech.mobile_usability?.status !== 'Pass')        failures.push('Mobile usability issues');
  if (tech.core_web_vitals?.status !== 'Pass')         failures.push('Core Web Vitals failing');
  if (!tech.sitemap?.status?.includes('Present'))      failures.push('Sitemap missing');
  if ((tech.schema_markup_types?.count || 0) === 0)   failures.push('No schema markup');
  const criticalText = failures.length ? failures.join(', ') : 'No critical failures found';

  // ── Strengths ──────────────────────────────────────────────────────────
  const strengths = [];
  if (domainAuthority >= 40)  strengths.push(`Strong domain authority (${domainAuthority}/100)`);
  if (mobilePerf >= 70)       strengths.push(`Fast mobile speed (${mobilePerf}/100)`);
  if (gmbRating >= 4.5)       strengths.push(`Excellent Google rating (${gmbRating}⭐ from ${gmbReviews} reviews)`);
  if (aiAvg >= 50)            strengths.push(`Good AI visibility (${aiAvg}/100)`);
  if (techScore >= 77)        strengths.push(`Strong technical health (${passCount}/${totalCount} checks passed)`);
  if (totalBacklinks > 500)   strengths.push(`${totalBacklinks.toLocaleString()} backlinks`);
  if (gmbReviews >= 50)       strengths.push(`${gmbReviews} Google reviews`);
  const strengthsText = strengths.length ? strengths.join(', ') : 'No clear strengths identified — all areas need attention';

  // ── Weakest area (normalised 0–100) ───────────────────────────────────
  const dimensionScores = {
    'Domain Authority':  domainAuthority,
    'Mobile Page Speed': mobilePerf,
    'AI Visibility':     aiAvg,
    'GMB Rating':        gmbRating > 0 ? Math.round((gmbRating / 5) * 100) : 0,
    'Technical Health':  techScore,
  };
  const [weakestName, weakestScore] = Object.entries(dimensionScores)
    .reduce((a, b) => a[1] < b[1] ? a : b);
  const weakestText = `${weakestName} (${weakestScore}/100)`;

  // ── Top competitor data ────────────────────────────────────────────────
  let topCompName = '', compDA = 0, compPerf = 0, compScore = 0, compGmbRating = 0;
  if (competitorsList.length) {
    const comp       = competitorsList[0];
    topCompName      = comp.name || cleanDomain(comp.website) || 'a competitor';
    compGmbRating    = comp.rating || 0;
    const compDomain = cleanDomain(comp.website);
    if (compDomain) {
      const compDAData  = loadDACached(`domainAuthority_${compDomain}`);
      compDA            = compDAData?.domain_authority ?? 0;
      const compPSData  = loadCached(`pageSpeedRaw_${compDomain}`);
      compPerf          = compPSData?.mobile?.performance_score ?? 0;
      const compSCache  = loadCached(`overallScore_${compDomain}`);
      compScore         = compSCache?.overallScore ?? 0;
    }
  }

  // ── Score label ────────────────────────────────────────────────────────
  const scoreLabel =
    overallScore >= 80 ? 'Excellent'   :
    overallScore >= 65 ? 'Strong'      :
    overallScore >= 45 ? 'Developing'  : 'Needs Work';

  // ── Competitor comparison line ─────────────────────────────────────────
  const compLines = [];
  if (compScore)       compLines.push(`Overall Score: ${compScore}/100`);
  if (compDA)          compLines.push(`Domain Authority: ${compDA}/100`);
  if (compPerf)        compLines.push(`Mobile Speed: ${compPerf}/100`);
  if (compGmbRating)   compLines.push(`Google Rating: ${compGmbRating}⭐`);
  const compSummary = compLines.length ? compLines.join(' | ') : 'Data not available';

  // ── Build the prompt ───────────────────────────────────────────────────
  const prompt = `You are a trusted digital marketing advisor who has just completed a full brand audit for ${brandName}. You are now speaking directly to the business owner, delivering your honest verdict.

Speak to them personally — use "your" and "you". Be warm, honest, and direct. Sound like a real person who cares, not a consultant writing a report.

RULES:
- No bullet points or numbered lists
- No jargon. No words like: leverage, synergy, holistic, robust, actionable, comprehensive, utilise, pivotal
- Exactly 3 paragraphs. Each paragraph is 2–3 sentences. Total word count: 90–120 words
- Every paragraph must reference at least one specific number from the data below
- The final sentence should feel like genuine, warm advice from someone who wants them to win

BRAND: ${brandName}
INDUSTRY: ${industry || 'local business / services'}
LOCATION: ${location || 'India'}

THEIR AUDIT RESULTS:
- Overall Brand Score: ${overallScore}/100 (${scoreLabel})
- Domain Authority: ${domainAuthority}/100 (backlinks: ${totalBacklinks.toLocaleString()}, referring domains: ${referringDomains})
- Mobile Page Speed: ${mobilePerf}/100 | Desktop: ${desktopPerf}/100
- Technical Health: ${passCount} of ${totalCount} checks passed (${techScore}%)
- AI Visibility: ${aiAvg}/100 (how often AI tools like Gemini, ChatGPT recommend them)
- Google Rating: ${gmbRating} stars from ${gmbReviews} reviews

MAIN COMPETITOR: ${topCompName || 'their main competitor'}
${compSummary}

WHAT IS BROKEN:
${criticalText}

WHAT IS WORKING:
${strengthsText}

SINGLE WEAKEST DIMENSION:
${weakestText}

NOW WRITE THE 3 PARAGRAPHS:

Paragraph 1 — Their honest current position. Reference the overall score (${overallScore}/100). Name one specific strength and one specific problem. Make them feel seen, not judged.

Paragraph 2 — The competitor reality. Compare them directly to ${topCompName || 'their main competitor'}. Who is winning right now and by how much? What does that gap actually mean when a customer is choosing between the two?

Paragraph 3 — The single most urgent fix: ${weakestName}. Tell them in plain terms what changes for their business in the next 30 days if they fix it, and what quietly keeps costing them if they don't. End with one warm, human sentence of encouragement.`;

  return {
    brandName, domain, websiteUrl, location, industry,
    overallScore, scoreLabel, domainAuthority, mobilePerf, desktopPerf,
    techScore, passCount, totalCount,
    aiAvg, gmbRating, gmbReviews,
    topCompName, compDA, compPerf, compScore,
    strengthsText, criticalText, weakestName, weakestScore, weakestText,
    dimensionScores, prompt,
  };
};

// ─────────────────────────────────────────────────────────────────────────
// Score Pill
// ─────────────────────────────────────────────────────────────────────────
const ScorePill = ({ value, label, thresholds = [70, 45] }) => {
  const color =
    value >= thresholds[0] ? '#0D9488' :
    value >= thresholds[1] ? '#C47D1A' : '#C0392B';
  return (
    <div className="fscore-pill">
      <span className="fscore-pill-val" style={{ color }}>{value}</span>
      <span className="fscore-pill-lbl">{label}</span>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Verdict Box with single Play/Pause toggle
// ─────────────────────────────────────────────────────────────────────────
const VerdictBox = ({ text, loading, error, onRegenerate }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const utteranceRef = useRef(null);

  // Cancel speech on unmount
  useEffect(() => {
    return () => window.speechSynthesis.cancel();
  }, []);

  // Single toggle: Play / Pause
  const togglePlayback = () => {
    const synth = window.speechSynthesis;

    if (isPlaying) {
      // Currently playing → pause
      synth.pause();
      setIsPlaying(false);
      setIsPaused(true);
    } else {
      // Not playing → either resume or start fresh
      if (isPaused && synth.paused) {
        synth.resume();
        setIsPlaying(true);
        setIsPaused(false);
      } else {
        // Cancel anything and start new
        synth.cancel();
        const utterance = new SpeechSynthesisUtterance(text.replace(/<[^>]*>/g, ''));
        utterance.lang = 'en-IN';
        utterance.onend = () => {
          setIsPlaying(false);
          setIsPaused(false);
        };
        utterance.onerror = () => {
          setIsPlaying(false);
          setIsPaused(false);
        };
        utteranceRef.current = utterance;
        synth.speak(utterance);
        setIsPlaying(true);
        setIsPaused(false);
      }
    }
  };

  return (
    <div className="verdict-box">
      <div className="verdict-header">
        <span className="verdict-label">Performance Summary</span>

        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {/* Single Play/Pause toggle button – only when text is ready */}
          {text && !loading && (
            <button className="play-btn" onClick={togglePlayback}>
              <svg viewBox="0 0 24 24" width="12" height="12">
                {isPlaying ? (
                  <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" /> // Pause icon
                ) : (
                  <path d="M8 5v14l11-7z" /> // Play icon
                )}
              </svg>
              {isPlaying ? 'Pause' : 'Play'}
            </button>
          )}
          {/* (Regenerate button is optional – you can uncomment if needed) */}
        </div>
      </div>

      {/* States */}
      {loading && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: '#6B4FA0', padding: '12px 0' }}>
          <div className="spinner" style={{ width: 16, height: 16, borderTopColor: '#6B4FA0' }} />
          Generating your AI Insight…
        </div>
      )}
      {error && !loading && (
        <div style={{ fontSize: 12, color: '#c62828', padding: '8px 0' }}>
          {error}{' '}
          <button onClick={onRegenerate} style={{ color: '#6B4FA0', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', fontSize: 12 }}>
            Try again
          </button>
        </div>
      )}
      {text && !loading && (
        <div className="verdict-text" style={{ marginTop: 10, lineHeight: 1.75, fontSize: 14, color: '#1C1626', whiteSpace: 'pre-line' }}>
          {text}
        </div>
      )}
      {!text && !loading && !error && (
        <div style={{ fontSize: 12, color: '#aaa', fontStyle: 'italic', padding: '8px 0' }}>
          Your final AI-powered verdict will appear here shortly.
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Dimension breakdown bar
// ─────────────────────────────────────────────────────────────────────────
const DimensionBar = ({ label, score, thresholds = [70, 45] }) => {
  const color =
    score >= thresholds[0] ? '#0D9488' :
    score >= thresholds[1] ? '#C47D1A' : '#C0392B';
  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
        <span style={{ color: '#555', fontWeight: 500 }}>{label}</span>
        <span style={{ color, fontWeight: 700 }}>{score}/100</span>
      </div>
      <div style={{ height: 6, borderRadius: 99, background: '#f0edf7', overflow: 'hidden' }}>
        <div style={{
          height: '100%', borderRadius: 99,
          width: `${Math.min(score, 100)}%`,
          background: color,
          transition: 'width 1s ease',
        }} />
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Client Dashboard Teaser
// ─────────────────────────────────────────────────────────────────────────
const DashTeaser = ({ onShowGate }) => {
  return (
    <div
      className="dash-teaser"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        background: 'rgba(107,79,160,0.06)',
        border: '1px solid rgba(107,79,160,0.15)',
        borderRadius: 16,
        padding: '18px 20px',
        marginTop: 16,
        flexWrap: 'wrap',
      }}
    >
      <div
        className="dash-teaser-icon"
        style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          background: '#EEEDFE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" fill="#534AB7">
          <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.2L19 8v8l-7 3.5L5 16V8l7-3.8zM11 7v6h2V7h-2zm0 8v2h2v-2h-2z" />
        </svg>
      </div>

      <div className="dash-teaser-body" style={{ flex: 1, minWidth: 220 }}>
        <div className="dash-teaser-title" style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink)', marginBottom: 4 }}>
          This is the free audit.
        </div>
        <p className="dash-teaser-desc" style={{ fontSize: 13, color: 'var(--muted)', margin: 0, lineHeight: 1.6 }}>
          The full picture is behind client login — deep-dive AI visibility, exactly where you're losing to each competitor, and prioritised recommendations your team can action.
        </p>
      </div>

      <button className="btn" style={{ marginTop: 0, flexShrink: 0 }} onClick={onShowGate}>
        Client Login — Full Dashboard
        <svg viewBox="0 0 24 24" fill="white">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z" />
        </svg>
      </button>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────
// Main Component
// ─────────────────────────────────────────────────────────────────────────
const FinalVerdict = () => {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [verdict, setVerdict] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError,   setAiError]   = useState('');
  const cacheKeyRef = useRef('');

  // ── Load audit data ────────────────────────────────────────────────────
  useEffect(() => {
    let settled = false;
    let interval;

    const tryLoad = () => {
      if (settled) return;
      const audit = buildAuditData();
      // Consider data ready if we have at least one real score
      const hasData = audit.domainAuthority > 0 || audit.mobilePerf > 0 || audit.overallScore > 0;
      if (hasData) {
        settled = true;
        clearInterval(interval);
        finalise(audit);
      }
    };

    const finalise = (audit) => {
      setData(audit);
      setLoading(false);
      const key = `final_verdict_${audit.domain}`;
      cacheKeyRef.current = key;
      // Try cache first
      const cached = loadAICached(key);
      if (cached) {
        setVerdict(cached);
      } else {
        generateVerdict(audit.prompt, key);
      }
    };

    tryLoad();
    interval = setInterval(tryLoad, 600);

    // Hard timeout — load whatever we have
    const timeout = setTimeout(() => {
      if (!settled) {
        clearInterval(interval);
        const audit = buildAuditData();
        finalise(audit);
      }
    }, 12000);

    return () => { clearInterval(interval); clearTimeout(timeout); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Generate verdict ───────────────────────────────────────────────────
  const generateVerdict = useCallback(async (prompt, cacheKey) => {
    if (!prompt) return;
    setAiLoading(true);
    setAiError('');
    setVerdict('');
    try {
      const text = await callGemini(prompt);
      setVerdict(text);
      saveAICache(cacheKey || cacheKeyRef.current, text);
    } catch (e) {
      console.error('Gemini verdict error:', e);
      setAiError('Could not generate the verdict. Please check your Gemini API key.');
    } finally {
      setAiLoading(false);
    }
  }, []);

  const handleRegenerate = () => {
    if (data) {
      // Bust the cache so we get a fresh response
      try { localStorage.removeItem(cacheKeyRef.current); } catch {}
      generateVerdict(data.prompt, cacheKeyRef.current);
    }
  };

  const handleDownloadPDF = () => {
    const orig = document.title;
    const safe = data?.brandName?.replace(/[^a-z0-9]/gi, '_').substring(0, 30) || 'brand';
    const date = new Date().toLocaleDateString('en-CA');
    document.title = `${safe}_Audit_${date}`;
    window.print();
    setTimeout(() => { document.title = orig; }, 1000);
  };

  // ── Client login gate ──────────────────────────────────────────────────
  // Wire this up to your actual client-login flow — e.g. navigate('/client-login'),
  // open a modal, or trigger whatever gate mechanism your app uses.
  const handleShowGate = () => {
    console.log('Show client login gate');
    // e.g. navigate('/client-login');
    // or: setShowLoginModal(true);
  };

  // ── Loading state ──────────────────────────────────────────────────────
  if (loading) {
    return (
      <div className="card" id="card-done">
        <div className="final-card-inner">
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div className="spinner" style={{ margin: '0 auto 16px' }} />
            <div style={{ fontSize: 14, color: '#6B4FA0' }}>Loading final audit data…</div>
          </div>
        </div>
      </div>
    );
  }

  if (!data) return null;

  const {
    brandName, overallScore, scoreLabel,
    domainAuthority, mobilePerf, techScore, passCount, totalCount,
    aiAvg, gmbRating, gmbReviews,
    topCompName, compDA, compPerf, compScore,
    dimensionScores,
  } = data;

  // ── Dynamic headline ───────────────────────────────────────────────────
  const [weakDim] = Object.entries(dimensionScores).reduce((a, b) => a[1] < b[1] ? a : b);

  let dynamicTitle = '', dynamicSubtitle = '';
  if (overallScore >= 75) {
    dynamicTitle    = `<strong>${brandName}</strong> — you're doing well. <em>Don't get comfortable.</em>`;
    dynamicSubtitle = `A score of ${overallScore}/100 is solid. But your ${weakDim} is a gap competitors could exploit.`;
  } else if (overallScore >= 50) {
    dynamicTitle    = `<strong>${brandName}</strong> has real potential. <em>It's just buried right now.</em>`;
    dynamicSubtitle = `You're sitting at ${overallScore}/100. Your ${weakDim} is what's holding everything back.`;
  } else {
    dynamicTitle    = `<strong>${brandName}</strong>, the market doesn't know you exist. <em>Yet.</em>`;
    dynamicSubtitle = `A score of ${overallScore}/100 means there's a lot of ground to cover — and a lot of quick wins waiting.`;
  }

  const today = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="card" id="card-done">
      <div className="final-card-inner">

        {/* ── Eyebrow ── */}
        <div className="final-eyebrow">Audit Complete</div>

        {/* ── Headline ── */}
        <h2 className="final-title" dangerouslySetInnerHTML={{ __html: dynamicTitle }} />
        <p className="final-subtitle">{dynamicSubtitle}</p>

       {/* ── Score Cards ── */}
        {[
          {
            label:     'Brand Score',
            value:     overallScore,
            threshold: [70, 45],
            icon: <path d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"/>,
            bgLight: '#FAECE7', iconColor: '#D85A30',
          },
          {
            label:     'Domain Authority',
            value:     domainAuthority,
            threshold: [40, 25],
            icon: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>,
            bgLight: '#FAEEDA', iconColor: '#BA7517',
          },
          {
            label:     'Page Speed',
            value:     mobilePerf,
            threshold: [70, 50],
            icon: <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>,
            bgLight: '#FAEEDA', iconColor: '#BA7517',
          },
          {
            label:     'Site Performance',
            value:     techScore,
            threshold: [77, 50],
            icon: <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>,
            bgLight: '#EAF3DE', iconColor: '#639922',
          },
          {
            label:     'AI Visibility',
            value:     aiAvg,
            threshold: [60, 30],
            icon: <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM9 14.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5.5 3.5h-5v-2h5v2zm.5-3.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>,
            bgLight: '#EEEDFE', iconColor: '#534AB7',
          },
        ].map(({ label, sub, value, threshold, icon, bgLight, iconColor }) => {
          const color = value >= threshold[0] ? '#0D9488'
                      : value >= threshold[1] ? '#C47D1A' : '#C0392B';
          return (
            <div key={label} style={{
              display: 'flex', alignItems: 'center', gap: 14,
              background: 'rgba(255,255,255,0.7)',
              border: '1px solid rgba(107,79,160,0.1)',
              borderRadius: 14, padding: '14px 18px',
              marginBottom: 10,
              backdropFilter: 'blur(8px)',
            }}>
              {/* Icon */}
              <div style={{
                width: 44, height: 44, borderRadius: 10,
                background: bgLight,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <svg viewBox="0 0 24 24" width="22" height="22" fill={iconColor}>
                  {icon}
                </svg>
              </div>

              {/* Label + subtitle + bar */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--ink)', marginBottom: 2 }}>
                  {label}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 8 }}>
                  {sub}
                </div>
                <div style={{ height: 4, borderRadius: 99, background: 'rgba(107,79,160,0.1)', overflow: 'hidden' }}>
                  <div style={{
                    height: '100%', borderRadius: 99,
                    width: `${Math.min(value, 100)}%`,
                    background: color,
                    transition: 'width 1s ease',
                  }} />
                </div>
              </div>

              {/* Score */}
              <div style={{ textAlign: 'right', flexShrink: 0, paddingLeft: 12 }}>
                <div style={{ fontSize: 26, fontWeight: 700, color, lineHeight: 1, fontFamily: '"Fraunces", serif' }}>
                  {value}
                </div>
                <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 2 }}>/100</div>
              </div>
            </div>
          );
        })}

        {/* ── AI Verdict ── */}
        <VerdictBox
          text={verdict}
          loading={aiLoading}
          error={aiError}
          onRegenerate={handleRegenerate}
        />

        {/* ── Client Dashboard Teaser ── */}
        <DashTeaser onShowGate={handleShowGate} />

        {/* ── Sign-off ── */}
        <div className="final-signoff" style={{ marginTop: 24 }}>
          <div className="signoff-text">
            Brand Audit Report
            <br />Generated on {today}
          </div>
        </div>

      </div>
    </div>
  );
};

export default FinalVerdict;